//const { detect } = require('detect-browser');

document.addEventListener('DOMContentLoaded',function() {

    const cover = document.getElementById('cover');
    
    const init = function() {
        document.documentElement.removeAttribute('style');
        //document.documentElement.classList.add('is-loaded');
        
        //setTimeout(function() {
            document.body.classList.add('is-loaded');
        //}, 250);
        
        setTimeout(function() {
            cover.remove();
            //window.anims();
        }, 500);

        // Anims on inview
        //window.animsInit()   
    };
    
    window.addEventListener('load', init);

}, false);
